import { useEffect } from "react";
import { addFaq, fetchFaqs } from "../../../../../store/action/faqAction";
import { connect } from "react-redux";
import FaqHeader from "./header";
import TableFaq from "./table";
import PreviewFaq from "./preview";
import { addZeros } from "../../../../../services/helpers/Helper";
const _ = require('lodash');

const Faq = (props) => {
   const { addFaq, fetchFaqs, faqs, page } = props;
   const maxQuestion = 4;
   useEffect(() => {
      if (!_.isEmpty(page)) {
         fetchFaqs();
      }
   }, [page]);

   const handleAddFaq = () => {
      addFaq({
         is_actived: false
      })
   }

   return (
      <div id="bot-scene-container" className="">
         <div id="bot-scene-content" className="scroll-light">
            <FaqHeader />
            <div className="app-v2-layout-content" style={{ background: 'white' }}>
               <div className="app-layout-d-flex">
                  <div className="table-wrapper-width table-wrapper-min-width">
                     <div className="table-wrapper scroll-light over-x-unset">
                        <TableFaq />
                     </div>
                     <div className="ice-breaker-list-footer">
                        <div className="display-inline-block">
                           <button className="btn btn-primary app-v2-btn-icon" onClick={handleAddFaq} disabled={faqs.length >= maxQuestion}>
                              <span className="btn-icon-wrapper">
                                 <span>
                                    <div className="svg-next-icon mr5 ic-plus-circle">
                                    </div>
                                 </span>
                                 <span>
                                    Thêm câu hỏi
                                 </span>
                              </span>
                           </button>
                        </div>
                        <span className="ice-breaker-warning-limit">
                           Bạn chỉ có thể đặt tối đa <b>{addZeros(maxQuestion)}</b> câu hỏi thường gặp.
                        </span>
                     </div>
                  </div>
                  <PreviewFaq />
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { faq, page } = state;
   const { items } = faq.faqs;

   return {
      faqs: items,
      page
   };
};

export default connect(mapStateToProps, {
   fetchFaqs,
   addFaq
})(Faq)
